const React = require('react')
const { useEffect, useState, useCallback, useRef } = require('react')
const { Row, Col, Container } = require('reactstrap')
const { useBlockchainData, useResponsive, BREAKPOINTS } = require('@hooks')

const { NETWORK_CONFIG } = require('@configs')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { GeneralStatistics } = require('./statistics.general.beaconHome')
// const { GeneralChart } = require('./chart.general.home')

require('@styles/pages/home/index.css')
require('@styles/pages/home/generalInfo.home/index.css')

const GeneralInfo = () => {
    const { network } = useNetworkConfig()
    const [data, setData] = useState()
    const [loading, setLoading] = useState(true)
    const { getBeaconGeneralInfo } = useBlockchainData(network.name)
    const isMobile = useResponsive(BREAKPOINTS.extraLarge)

    const isFirstFetch = useRef(true)
    const intervalRef = useRef(null)

    const fetchData = useCallback(async () => {
        try {
            const [infoResponse] = await Promise.all([getBeaconGeneralInfo()])
            if (infoResponse) {
                setData(infoResponse)
            }
        } catch (error) {
            console.error('Error fetching network info:', error)
        } finally {
            if (isFirstFetch.current) {
                setLoading(false)
                isFirstFetch.current = false
            }
        }
    }, [network])

    useEffect(() => {
        fetchData()

        intervalRef.current = setInterval(fetchData, NETWORK_CONFIG[network.name].timeInterval)

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [network, fetchData])

    return (
        <div className='general-info'>
            {loading ? (
                <Container
                    className='box d-flex justify-content-center align-items-center'
                    style={{ minHeight: '180px' }}
                >
                    <LoadingSpinner />
                </Container>
            ) : (
                <Container>
                    <Row style={{ margin: '0' }}>
                        <Col
                            style={{
                                borderRadius: '10px'
                            }}
                            className={`box`}
                        >
                            <Row>
                                <Col sm='6' className={`${!isMobile && 'general-statistics-wrapper'}`}>
                                    <GeneralStatistics
                                        title={['Current Epoch', 'Finalized Epoch']}
                                        value={[data?.currentEpoch, data?.finalizedEpoch]}
                                        link={[
                                            `/${network.name}/epoch/${data?.currentEpoch}`,
                                            `/${network.name}/slot/${data?.currentSlot}`
                                        ]}
                                    />
                                    <GeneralStatistics
                                        title={['Current Slot', 'Finalized Slot']}
                                        value={[data?.currentSlot, data?.finalizedSlot]}
                                        link={[
                                            `/${network.name}/epoch/${data?.finalizedEpoch}`,
                                            `/${network.name}/slot/${data?.finalizedSlot}`
                                        ]}
                                    />
                                </Col>
                                <Col sm='6'>
                                    <GeneralStatistics
                                        title={['Active Validators', 'Pending']}
                                        value={[data?.activeValidatorsCount, data?.pendingValidatorsCount]}
                                        link={[
                                            `/${network.name}/validators#active`,
                                            `/${network.name}/validators#pending`
                                        ]}
                                    />
                                    <GeneralStatistics
                                        title={[`Voted ${network.data.token}`, `Eligible ${network.data.token}`]}
                                        value={[
                                            <>
                                                {data?.votedBalance / 10 ** 9}&nbsp;
                                                <span style={{ color: 'var(--grey-color)' }}>
                                                    ({((data?.votedBalance / data?.eligibleBalance) * 100).toFixed(2)}%)
                                                </span>
                                            </>,
                                            data?.eligibleBalance / 10 ** 9
                                        ]}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

module.exports = { GeneralInfo }
